import React, { Component } from "react";
import { BrowserRouter as Router, Switch, Redirect } from "react-router-dom";
import autobind from "autobind-decorator";

import RouteItem from "./routing/RouteItem";
import Routes from "./Routes";
import store from "./store";
import { AUTH_CHECK } from "./store/actions";

import {Helmet} from "react-helmet";
import { I18nextProvider } from 'react-i18next';
import i18n from '../i18n';

export default class App extends Component {
    state = {
        loading: false,
    };

    constructor(props: Map<any, any>) {
        super(props);

        store.dispatch({
            type: AUTH_CHECK,
        });
    }

    componentDidMount() {
        setTimeout(() => {
            this.setState({
                loading: false,
            });

            const appLoading: HTMLElement = document.getElementById("app-loading");
            this.removeElement(appLoading, "opacity", 1, 0, 500, () => {
                appLoading.remove();
            });
        }, 500);
    }

    @autobind
    removeElement(element: HTMLElement, property: string, startValue: any, endValue: any, time: number, callback: Function) {
        const frameRate = 0.06;
        let frame = 0;

        const delta = ((endValue - startValue) / time) / frameRate;
        let handle = setInterval(() => {
            ++frame;

            const value = (startValue + delta * frame).toFixed(2);
            element.style[property] = parseFloat(value);

            if (value == endValue) {
                clearInterval(handle);
                callback();
            }
        }, 1 / frameRate);
    }

    render() {
        // return <div>
        //     <I18nextProvider i18n={i18n}>
        //     {!this.state.loading && <Router>
        //         <Switch>
        //             {Routes.redirectList().map((redirect, i) => (
        //                 <Redirect key={i} {...redirect} />
        //             ))}
        //
        //             {Routes.routeList().map((route, i) => (
        //                 <RouteItem key={i} {...route} />
        //             ))}
        //         </Switch>
        //     </Router>}
        //     </I18nextProvider>
        // </div>
        return <div>
            {!this.state.loading && <Router>
                <Switch>
                    {Routes.redirectList().map((redirect, i) => (
                        <Redirect key={i} {...redirect} />
                    ))}

                    {Routes.routeList().map((route, i) => (
                        <RouteItem key={i} {...route} />
                    ))}
                </Switch>
            </Router>}
        </div>;
    }
}
